<!-- <mapfre-modal [modalOptions]="claimModal" [hideModal]="hideModal" (hideModalOutput)="resetHideModal()"> -->
<mapfre-modal 
  [modalOptions]="claimModal" 
  [hideModal]="hideModal"
  (hideModalOutput)="resetHideModal()"
>

 <div class="modal-body policy-selector-widget-modal" [ngClass]="{'modal-padded-md':!isAcmic }">
    <div class="text-center">
        <div class="modal-icon-box-center">
            <img src={{modalIcon}} alt="Report a claim icon"/>
        </div>
        <div class="widget-modal-title">{{ 'Report a claim' | translate }}</div>
        <div class="widget-modal-sub-title">
          {{ "To get started, please select the policy related to your claim." | translate }}
        </div>
    </div>

    <hr class="border-top">
    <ng-container *ngFor="let pol of policies">
      <div (click)="onReportClaimClick(pol)" class="d-flex cursor-pointer mb-3 mt-3">
        <div class="policy-type-icon-box">
          <ng-container *ngIf="isAcmic; else maClaimIcons">
              <img 
                  src="{{pol?.displayType?.icon}}"
                  class="claim-modal-icon-ml"
                  width="32" height="32" 
                  alt="{{pol?.policyType?.toLowerCase()}} icon" 
              />                           
          </ng-container>
          <ng-template #maClaimIcons>
              <img 
                  src="{{pol?.displayType?.icon}}"
                  width="30" height="30" 
                  alt="{{pol?.policyType?.toLowerCase()}} icon" 
              />                       
          </ng-template>
        </div>
        <div class="policy-type-select-row">
          <div class="nowrap ml-2">
              {{ pol?.displayType?.label }}
                &ndash;
              {{ pol?.policynumber?.policyNumber }}
          </div>

          <div class="d-flex-select-row">
              <ng-container *ngIf="isAcmic; else maArrowIcon">
                  <img src="assets/img/images/widgets/select-arrow-acmic.svg" alt="right arrow icon" />
              </ng-container>
                <ng-template #maArrowIcon>
                  <span class="select-link"> Select </span>
                  <img src="assets/img/images/widgets/select-arrow.svg" alt="right arrow icon" />
              </ng-template>
          </div>
        </div>
      </div>

      <hr class="border-top">        
    </ng-container>

    <div class="policy-selector-button-row">
      <mapfre-button 
          (click)="resetHideModal()"
          additionalClasses="btn mapfre ghost secondary x-small-btn modal-cancel-btn"
      >
        {{ "CANCEL" | translate }}
      </mapfre-button>
    </div>
  </div>
</mapfre-modal>